import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, pluck, publishReplay, refCount, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  // custom footer configurable per country
  FOOTER_FEATURES_CONFIG = '../../../public/features/FOOTER_FEATURES.json';

  cacheWindowTime = 3600000;
  private cachedFooterFeaturesConfig$: any = {};

  constructor(private http: HttpClient) {}

  getFooterFeaturesConfig$(activeCountry: string): Observable<any> {
    if (!this.cachedFooterFeaturesConfig$[activeCountry]) {
      this.cachedFooterFeaturesConfig$[activeCountry] = this.http
        .get(this.FOOTER_FEATURES_CONFIG)
        .pipe(publishReplay(1, this.cacheWindowTime), refCount(), take(1), catchError(this.errorHandler));
    }
    return this.cachedFooterFeaturesConfig$[activeCountry];
  }

  getBreakAfterIndex(activeCountry: string, activeLanguage: string, device: string): Observable<number[]> {
    const idString = [activeCountry, activeLanguage, device].join();
    if (!this.cachedFooterFeaturesConfig$[idString]) {
      this.cachedFooterFeaturesConfig$[idString] = this.getFooterFeaturesConfig$(activeCountry).pipe(
        publishReplay(1, this.cacheWindowTime),
        refCount(),
        take(1),
        pluck('country'),
        map((data: any) => (data[activeCountry] ? data[activeCountry] : data['default'])),
        pluck('language'),
        map((data) =>
          data[activeLanguage] !== undefined
            ? data[activeLanguage][device]['breakAfterIndex']
            : data['default'][device]['breakAfterIndex']
        ),
        catchError(this.errorHandler)
      );
    }
    return this.cachedFooterFeaturesConfig$[idString];
  }

  errorHandler(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
